export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6948.b8a698bd.jpg";